<template>
  <div class="filter-window text-2xl">
    <div class="filter-block">
      <div class="flex justify-between align-middle mb-5">
        <input v-if="false" v-model="search" type="text" placeholder="suche ..." autofocus class="mr-4" />
        <h2 v-else>Anzeige filtern</h2>
        <span @click="$emit('window-close')" class="cursor-pointer">
          <i class="fa fa-times"></i>
        </span>
      </div>
      <!-- referents -->
      <div class="mb-2">
        <span
          @click="toggle_filter_options"
          class="title cursor-pointer"
          ><i class="fa"
              :class="{ 'fa-chevron-right': !display_referents,
                        'fa-chevron-down': display_referents }"></i> Referenten:</span
        >
        <span
          class="tag"
          :class="{ selected: referent_filter_is_empty }"
          @click="clear_referent_filter()"
          >Alle</span
        >
        <span v-if="display_referents">
          <span
            v-for="referent in referents"
            :key="referent.id"
            class="tag"
            :class="{ selected: in_referent_filter(referent) }"
            @click="toggle_referent_filter(referent)"
          >
            {{ referent.firstname }} {{ referent.lastname }}
          </span>
        </span>
      </div>
      <div>
        <span @click="toggle_filter_options" class="title cursor-pointer">
          <i class="fa"
             :class="{ 'fa-chevron-right': !display_categories,
                       'fa-chevron-down': display_categories }"></i> Kategorien:</span>
        <span
          class="tag"
          :class="{ selected: filter_is_empty }"
          @click="clear_filter()"
          >Alle</span
        >
        <span v-if="display_categories">
          <span
            v-for="cat in filtered_categories"
            :key="cat.id"
            class="tag"
            :class="{ selected: in_filter(cat) }"
            @click="toggle_filter(cat)"
          >
            {{ cat.title }}
          </span>
        </span>
      </div>
    </div>
    <div v-if="false" class="filter-block">
      <span class="title">@ate:</span>
      <span class="tag selected">Alle</span>
      <span class="tag">Audio</span>
      <span class="tag">Video</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"

export default {
  data() {
    return {
      search: '',
      display_referents: true,
      display_categories: false,
    }
  },
  computed: {
    ...mapState(["categories", "filter_by_categories", "filter_by_referents"]),
    ...mapGetters(["referents"]),
    filtered_categories() {
      return this.categories.filter((c) => [1,2,3,4,5,7].includes(c.id))
    },
    filter_is_empty() {
      return this.filter_by_categories.length <= 0
    },
    referent_filter_is_empty() {
      return this.filter_by_referents.length <= 0
    },
  },
  methods: {
    window_close() {
      this.$emit("close")
    },
    clear_filter() {
      while (this.filter_by_categories.length) {
        this.filter_by_categories.pop()
      }
    },
    clear_referent_filter() {
      while (this.filter_by_referents.length) {
        this.filter_by_referents.pop()
      }
    },
    toggle_filter_options() {
      this.display_referents = ! this.display_referents
      this.display_categories = ! this.display_referents
      if ( this.display_referents ) {
        this.clear_filter()
      } else {
        this.clear_referent_filter()
      }
    },
    toggle_filter(cat) {
      this.clear_filter()
      this.filter_by_categories.push(cat)

      // if( this.filter_by_categories.find( (f) => f.id === cat.id ) ) {
      //   this.filter_by_categories.splice( this.filter_by_categories.indexOf( cat ), 1 )
      // } else {
      //   this.filter_by_categories.push( cat )
      // }
      console.log(this.filter_by_categories)
    },
    toggle_referent_filter(referent) {
      this.clear_referent_filter()
      this.filter_by_referents.push(referent)
      console.log(this.filter_by_referents)
    },
    in_filter(cat) {
      return this.filter_by_categories.find((f) => f.id === cat.id)
    },
    in_referent_filter(referent) {
      return this.filter_by_referents.find((f) => f.id === referent.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-window {
  z-index: 4;
  // opacity: 0;
  transition: opacity 0.4s ease-in-out;
  padding: 10px;
  float: left;
  position: absolute;
  width: 400px;
  background-color: white;
  right: -6px;
  top: -13px;
  box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.2);
}
.filter-block {
  .title {
    font-weight: 600;
  }
  .tag {
    display: inline-block;
    padding: 2px 4px;
    margin-bottom: 2px;
    border: 1px solid transparent;

    &:hover {
      cursor: pointer;
      border: 1px solid rgba(248, 5, 5, 0.637);
      background-color: rgba(248, 5, 5, 0.637);
      color: white;
      border-radius: 4px;
    }
    & .ml-2 {
      margin-left: 5px;
    }
  }
  .selected {
    border: 1px solid rgba(248, 5, 5, 0.637);
    background-color: rgba(248, 5, 5, 0.637);
    color: white;
    border-radius: 4px;
  }
}
</style>
